import { Link, NavLink } from "react-router-dom";
import { Compass } from "lucide-react";

const navItem = ({ isActive }) =>
  `text-sm tracking-wide transition-colors duration-300 ${isActive ? "text-white" : "text-white/60 hover:text-white"}`;

export default function Navbar() {
  return (
    <header className="fixed top-0 left-0 w-full z-50 glass border-b border-white/5" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="brand-link">
          <span className="w-8 h-8 grid place-items-center border border-white/15 rounded-sm group-hover:border-[var(--pov-coral)] transition-colors">
            <Compass className="w-4 h-4 text-[var(--pov-coral)]" />
          </span>
          <span className="font-display tracking-wider text-sm sm:text-base">
            POINT <span className="text-white/40">OV</span> VIEW
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/" end className={navItem} data-testid="nav-home">Home</NavLink>
          <a href="/#who" className="text-sm text-white/60 hover:text-white transition-colors" data-testid="nav-who">Who We Are</a>
          <a href="/#rooms" className="text-sm text-white/60 hover:text-white transition-colors" data-testid="nav-rooms">Rooms</a>
          <a href="/#fields" className="text-sm text-white/60 hover:text-white transition-colors" data-testid="nav-fields">Expertise</a>
          <a href="/#portfolio" className="text-sm text-white/60 hover:text-white transition-colors" data-testid="nav-portfolio">Work</a>
          <NavLink to="/book" className={navItem} data-testid="nav-book">Book</NavLink>
        </nav>

        <Link to="/book" className="btn-primary text-sm" data-testid="navbar-cta">
          Begin
        </Link>
      </div>
    </header>
  );
}
